import PropTypes from 'prop-types';
import React from 'react';
import Icon from './Icon';
import { getComponentClasses } from '@99designs/utils/app';

export default class LinkWithIcon extends React.Component {
    getLinkChildren() {
        return [
            <span className="link-with-icon__icon" key="icon">
                {this.props.icon}
            </span>,
            <span className="link-with-icon__label" key="label">
                {this.props.children}
            </span>,
        ];
    }

    render() {
        const classes = getComponentClasses('link-with-icon', this.props.variations);
        const props = Object.assign({}, this.props);
        delete props.variations;
        delete props.params;
        delete props.icon;
        return (
            <a {...props} className={classes}>
                {this.getLinkChildren()}
            </a>
        );
    }
}

LinkWithIcon.propTypes = {
    href: PropTypes.string.isRequired,
    variations: PropTypes.array,
    icon: PropTypes.shape({
        type: PropTypes.oneOf([Icon]),
    }),
};

LinkWithIcon.defaultProps = {
    variations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/LinkWithIcon.jsx